import { Backdrop, CircularProgress } from "@mui/material";
import { useContextProvider } from "../page-context/ContextProvider";

const Loading = () => {
  const { isLoading } = useContextProvider();
  return (
    <Backdrop open={isLoading} sx={{ color: "#fff", backgroundColor: "rgba(0, 0, 0, 0.1)", zIndex: (t) => t.zIndex.modal + 1 }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
export default Loading;
